import React from "react";

import { useAppDispatch, useAppSelector } from "store";
import {
    selectRetailCentresWithScores,
    selectTarget
} from "modules/customer/tools/location/locationSlice";
import {
    loadSuggestedNewLocationsSetup,
    hideSuggestedNewLocations,
    selectSuggestedNewLocationsVisibility,
    showSuggestedNewLocations,
} from "modules/customer/tools/location/suggestedNewLocations/suggestedNewLocationsSlice";

import { Box, Button } from "@material-ui/core";
import LocationSearchingRoundedIcon from '@material-ui/icons/LocationSearchingRounded';
import { useTheme, withStyles } from "@material-ui/core/styles";

import Table from "./Table";
import Title from "./Title";
import SimpleDialog from "components/SimpleDialog";

const StyledButton = withStyles(theme => ({
    root: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.background.default,
        borderColor: theme.palette.common.white,
        "&:hover": {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.background.default
        },
        width: "100%"
    },
    label: {
        justifyContent: "left"
    }
}))(Button);

const SuggestedNewLocations: React.FC = () => {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const retailCentresWithScores = useAppSelector(selectRetailCentresWithScores);
    const target = useAppSelector(selectTarget);
    const suggestedNewLocationsVisibility = useAppSelector(selectSuggestedNewLocationsVisibility);

    React.useEffect(() => {
        if (retailCentresWithScores.length > 0 && target) {
            dispatch(loadSuggestedNewLocationsSetup());
        }
    }, [dispatch, retailCentresWithScores, target]);

    const handleClick = () => {
        dispatch(showSuggestedNewLocations());
    };

    const handleClose = () => {
        dispatch(hideSuggestedNewLocations());
    };

    return (
        <>
            <Box paddingTop={2}>
                <StyledButton
                    variant="outlined"
                    color="default"
                    disableElevation
                    size="small"
                    startIcon={<LocationSearchingRoundedIcon />}
                    onClick={handleClick}
                    data-cy="btn-suggested-new-locations"
                >
                    Suggested new locations
                </StyledButton>
            </Box>
            <SimpleDialog
                backgroundColor={theme.palette.background.paper}
                open={suggestedNewLocationsVisibility.isVisible}
                onClose={handleClose}
                maxWidth="lg"
                fullHeight={true}
                disableEnforceFocus={true}
                title={<Title />}
                content={<Table />}
            />
        </>
    );
};

export default SuggestedNewLocations;
